import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import CustomButton from "../Button/CustomButton";
import CustomDialog from "../Dialog/CustomDialog";
import CustomTextField from "../Input/CustomTextField";
import { tesaWhite } from "../../styles/colors";
import GalleryFlag from "./model/GalleryFlag.model";
import useUploadDialogStyles from "./UploadDialog.styles";

interface AttachmentDialogProps {
  open: { flag?: GalleryFlag } | null;
  onClose: () => void;
  onSubmit: (filesForUpload: File[], description: string, flag?: GalleryFlag) => void;
  onAlert: (alert: string) => void;
  header?: string;
}

const AttachmentDialog: React.FC<AttachmentDialogProps> = (props) => {
  const classes = useUploadDialogStyles(props);
  const { open, onClose, onSubmit, onAlert, header } = props;

  const [description, setDescription] = useState("");
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [headline, setHeadline] = useState(header || "Upload Attachment");
  useEffect(() => {
    if (!open) {
      setDescription("");
      setSelectedFiles([]);
    }
    if (open?.flag) {
      const uploadHeader = `Upload ${open.flag.longLabel || open.flag.label}`;
      setHeadline(`${header || uploadHeader}`);
    }
  }, [open]);

  useEffect(() => {
    setHeadline(header || "Upload Attachment");
  }, [header]);

  const handleUploadClick = () => {
    onClose();
    onSubmit(selectedFiles, description, open?.flag);
  };

  const KB = 1024;
  const MB = 1024 * KB;
  return (
    <>
      <CustomDialog onClose={onClose} open={!!open}>
        <div>
          <Grid container>
            <h2 className={classes.header}>{headline}</h2>
            <Grid item lg={12} md={12} sm={12} xs={12} className={classes.MuiDropzoneArea}>
              <DropzoneArea
                onChange={setSelectedFiles}
                acceptedFiles={open?.flag?.restriction?.acceptedFiles}
                showAlerts={false}
                onAlert={(message) => {
                  if (message) {
                    onAlert(message);
                  }
                }}
                getFileAddedMessage={() => ""}
                getFileRemovedMessage={() => ""}
                getDropRejectMessage={(rejectedFile: File) => {
                  if (open?.flag?.restriction && rejectedFile.size <= 500 * MB) {
                    return `Upload not possible. The file type is not allowed.
                  (Please use ${open.flag.restriction.label})`;
                  }
                  return "Upload not possible. The file size is too big.";
                }}
                getFileLimitExceedMessage={() => "Upload not possible. Maximum file limit is 25."}
                maxFileSize={500 * MB}
                showPreviewsInDropzone
                useChipsForPreview
                previewChipProps={{ style: { backgroundColor: tesaWhite } }}
                filesLimit={25}
              />
            </Grid>
            <Grid item xs={12} className={classes.textField}>
              <CustomTextField
                label="Description"
                name="description"
                id="description"
                type="text"
                multiline
                rows={3}
                onChange={(event) => setDescription(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomButton
                className={classes.alignRight}
                primary
                text="Upload"
                type="submit"
                onClick={handleUploadClick}
                disabled={selectedFiles.length === 0}
              />
            </Grid>
          </Grid>
        </div>
      </CustomDialog>
    </>
  );
};

export default AttachmentDialog;
